import { NativeService } from './../../../services/native.service';
import { VehicleSummaryModel } from 'app/models/dms/vehicle.model';
import { VehicleSearchResultModel } from 'app/models/dms/vehicleSearchResult.model';
import { ContactListComponent } from '../contact-list/contact-list.component';
// import { SelectContactSearchComponent } from './select-contact-search.component';

import { ModalController } from '@ionic/angular';
import { Component, OnInit, OnChanges, EventEmitter, Input, Output } from '@angular/core';
import { SelectVehicleSearchComponent } from './select-vehicle-search.component';


@Component({
    selector: 'app-select-vehicle',
    templateUrl: './select-vehicle.component.html',
    styleUrls: ['./select-vehicle.component.scss'],
    standalone: false
})
export class SelectVehicleComponent implements OnInit {

	@Input() id: string;
	@Input() value: string;
	@Input() label: string;
	@Input() selectedValue: string;
	@Input() classes: string;
	@Input() editable: boolean = true;
	@Input() sideload: VehicleSummaryModel;

	@Output() mcChange: EventEmitter<VehicleSummaryModel> = new EventEmitter<VehicleSummaryModel>();

	constructor(public modalController: ModalController, protected nativeService: NativeService)
	{


	}

	ngOnInit()
	{
		var vehicle = this.sideload;
		if (vehicle) {
			this.id = vehicle.vehicleId;
			this.selectedValue = vehicle.stockNo+ " • " +vehicle.yearManuModelCaption;
		}
	}

	async showModal()
	{
		if (!this.editable) return;
		var statusBarColor = this.nativeService.currentColor;
		this.nativeService.setupStatusBar("light");
		const modal = await this.modalController.create({
			component: SelectVehicleSearchComponent,
			componentProps: {
				'title': ''+this.label,
				'selectedVehicle':this.selectedValue,
				'selectedVehicleId': this.value,
			}
		});
		await modal.present();
		const { data } = await modal.onDidDismiss();
		this.nativeService.setupStatusBar(statusBarColor);
		
		if (data && data.vehicle)
		{
			// console.log("Modal dismissed ", data);
			this.setVehicle(data.vehicle);
		}
	}

	private setVehicle(vehicle: VehicleSummaryModel)
	{
		this.id = vehicle.vehicleId;
		this.selectedValue = vehicle.stockNo+ " • " +vehicle.yearManuModelCaption
		this.mcChange.emit(vehicle);
	}

	public getSelectedValue() 
	{
		return this.selectedValue?this.selectedValue:'-';
	}

	public itemHasValue() 
	{
		return (this.selectedValue&&this.selectedValue!='-')?true:false;
	}
	scrollTop: boolean = true;
	ionScrollEvent(ev:any){
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop!=scrollTop) {
			this.scrollTop = scrollTop;
		}
	}
}
